import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import moment from 'moment';
import PropTypes from 'prop-types';
 import { makeStyles } from '@material-ui/styles';
 import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/DeleteOutline';
import ModalImage from "react-modal-image";
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Checkbox,
  Divider,
  Typography,
  Table,
  TableBody,
  Avatar,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  colors,
  Switch
} from '@material-ui/core';

import { Label,  TableEditBar } from '../../../../components';

const useStyles = makeStyles(theme => ({
  root: {
  },
  filterButton: {
    marginRight: theme.spacing(2)
  },
  content: {
    padding: 0,
    overflowX: 'auto',
  },
  inner: {
  // minWidth: 1150
  },
  actions: {
    padding: theme.spacing(0, 1),
   // justifyContent: 'flex-end'
  }
}));

const Results = props => {
  const { className, orders,onDelete, ...rest } = props;

  const classes = useStyles();

  const [selectedOrders, setSelectedOrders] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [showpreview, setShowpreview] = useState(false);
  const [previewurl, setpreviewurl] = useState('');

  const handleSelectAll = event => {
    const selectedOrders = event.target.checked
      ? orders.map(order => order.id)
      : [];

    setSelectedOrders(selectedOrders);
  };
  function previewimage(url)
  {
    setpreviewurl(url)
    setShowpreview(true)
  }
  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedOrders.indexOf(id);
    let newSelectedOrders = [];

    if (selectedIndex === -1) {
      newSelectedOrders = newSelectedOrders.concat(selectedOrders, id);
    } else if (selectedIndex === 0) {
      newSelectedOrders = newSelectedOrders.concat(selectedOrders.slice(1));
    } else if (selectedIndex === selectedOrders.length - 1) {
      newSelectedOrders = newSelectedOrders.concat(selectedOrders.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedOrders = newSelectedOrders.concat(
        selectedOrders.slice(0, selectedIndex),
        selectedOrders.slice(selectedIndex + 1)
      );
    }

    setSelectedOrders(newSelectedOrders);
  };
  const toggleChecked = (order, index) => e => {
     
    order['status'] =  e.target.checked
    props.onDelete(order)
 
};
  const handleChangePage = (event, page) => {
    setPage(page);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(event.target.value);
  };

  const paymentStatusColors = {
    canceled: colors.grey[600],
    pending: colors.orange[600],
    active: colors.green[600],
    inactive: colors.red[600]
  };

  return (
    <>
    
    {showpreview && (
          <Lightbox
            mainSrc={previewurl}
           // nextSrc={images[(photoIndex + 1) % images.length]}
           // prevSrc={images[(photoIndex + images.length - 1) % images.length]}
            onCloseRequest={() => setShowpreview(false)}
            onMovePrevRequest={() =>
              alert('prev')
            }
            onMoveNextRequest={() =>
              alert('next')
            }
          />
        )}
        
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
     
      <Card>
        {/* <CardHeader
          
          title="Futures"
        />
        <Divider /> */}
        <CardContent className={classes.content}>
            <div className={classes.inner}>
              <Table>
                <TableHead>
                  <TableRow>
                    {/* <TableCell padding="checkbox">
                      <Checkbox
                        checked={selectedOrders.length === orders.length}
                        color="primary"
                        indeterminate={
                          selectedOrders.length > 0 &&
                          selectedOrders.length < orders.length
                        }
                        onChange={handleSelectAll}
                      />
                    </TableCell> */}
                    <TableCell>S no</TableCell>
                    <TableCell>Commodity Name</TableCell>
                    <TableCell>Image / Video</TableCell>
                    <TableCell>Title</TableCell>
                  
                    <TableCell>Status</TableCell>
                    <TableCell>CreatedAt</TableCell>
                    <TableCell align="center" minWidth={200}>Edit</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {orders.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((order,index) => (
                    <TableRow
                      key={order.id}
                      selected={selectedOrders.indexOf(order.id) !== -1}
                    >
                      {/* <TableCell padding="checkbox">
                        <Checkbox
                          checked={selectedOrders.indexOf(order.id) !== -1}
                          color="primary"
                          onChange={event => handleSelectOne(event, order.id)}
                          value={selectedOrders.indexOf(order.id) !== -1}
                        />
                      </TableCell> */}
                      <TableCell>
                        {(page * rowsPerPage)+(index+1)}
                        
                      </TableCell>

                      <TableCell>{order?.spot_commodities?.map((commodity,index) => (
                          <Label
                          color={paymentStatusColors['canceled']}
                          variant="contained"
                        >
                          {commodity.master_commodity.name}
                        </Label>
                      ))}</TableCell>     
                        <TableCell>{order?.spot_languages?.map((commodity,index) => (
                          <Label
                          color={paymentStatusColors['canceled']}
                          variant="contained"
                        >
                          {commodity?.master_language?.name}
                        </Label>
                      ))}</TableCell>              
                      {/* <TableCell>                        
                        <Avatar alt={order.title} src={order.imageurl} onClick={() =>previewimage(order.imageurl)} />
                    </TableCell> */}
                      <TableCell>{order.title}</TableCell>
            
                      <TableCell>
                         {/* <Label
                          color={paymentStatusColors[order.status ? 'active' : 'inactive']}
                          variant="contained"
                        >
                          {order.status ? 'Active' : 'In Active'}
                        </Label> */}
                        <Switch
                            checked={order.status}
                            onChange={toggleChecked(order,index)}
                            color="primary"
                            name="checkedA"
                            inputProps={{ 'aria-label': 'secondary checkbox' }}
                          />

                      </TableCell>
                      <TableCell>

                      <Typography variant="body1">
                      {moment.utc(order.createdAt).local().format(
                            'DD MMM YYYY hh:mm a'
                          )}
                        </Typography>
                      </TableCell>
                     
                      
                      <TableCell align="center">
                      <Button component={RouterLink}
                         to={`/editspot/${order.id}`} ><EditIcon 
                         
                      />
                           </Button>
                           {/* <Button  ><DeleteIcon onClick={() =>onDelete(order)}/>
                           </Button> */}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
        </CardContent>
        <CardActions className={classes.actions}>
          <TablePagination
            component="div"
            count={orders.length}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            page={page}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[5, 10, 25,100]}
          />
        </CardActions>
      </Card>
      <TableEditBar selected={selectedOrders} />
    </div>
    </>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  orders: PropTypes.array.isRequired
};

Results.defaultProps = {
  orders: []
};

export default Results;
